(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('editEstadioFenologico', EditEstadioFenologicoDirective);

  function EditEstadioFenologicoDirective() {
    return {
      restrict: 'E',
      templateUrl: 'views/estadios_fenologicos/edit.html',
      controller: 'EstadiosFenologicosEditCtrl',
      controllerAs: 'edit',
      scope: {
        estadio: '<',
        atividades: '<'
      },
      bindToController: true
    };
  }
}());
